import { ComponentStyleConfig } from '@chakra-ui/react';

const getPlatformPaddingTopPx = (
  isElectronBuild: boolean,
  isMobile: boolean
) => {
  if (isElectronBuild) {
    return 0;
  }
  if (isMobile) {
    return 32;
  }
  return 4;
};

export const AuthContentWrapper: ComponentStyleConfig = {
  parts: ['container', 'centeredLayout', 'logo'],
  baseStyle: ({ isElectronBuild, isMobile }) => ({
    container: {
      display: 'flex',
      height: '100%',
      width: '100%',
      overflowY: 'visible',
      overflowX: 'hidden',
      px: 4,
    },
    centeredLayout: {
      height: '100%',
      paddingTop: `${getPlatformPaddingTopPx(isElectronBuild, isMobile)}px`,
      paddingBottom: 4,
      paddingLeft: 0,
      paddingRight: 0,
      justifyContent: 'start',
      textAlign: 'start',
      _before: {
        content: '""',
        height: '100%',
        maxHeight: isMobile ? '0px' : '107px',
      },
    },
  }),
  sizes: {},
  variants: {},
  defaultProps: {},
};
